import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const StripeMimicButton = ({ iconSrc, text, onSelected, isSelected }) => (
  <button
    onClick={e => {
      e.preventDefault();
      onSelected();
    }}
    className={classNames(
      'courses-checkout-payment__stripe-mimic-button',
      isSelected && 'courses-checkout-payment__stripe-mimic-button--selected',
    )}
  >
    <img src={iconSrc} alt={text} />
    <span>{text}</span>
  </button>
);

export default StripeMimicButton;
